export default "__VITE_ASSET__Bch0W5F$__"